//modulo de autenticacion
import firebase from 'firebase';


export default {
    state: {
        user: null,
        role: 'guest',
        name: null,
        logged: false, 
        imgUrl: false,
        phone: null,
        lastName: null

    },
    //acciones de autenticacion de Firebase
    actions: {
      
        firebaseLogout: () => {
            return firebase.auth().signOut();
        },

    },
    //mutaciones para cambiar los estados de la sesion
    mutations: {
        setUser: (state, user) => {
            if (user) {
                state.user = {
                    uid: user.uid,
                    email: user.email
                };
                state.logged = true;
            } else {
                state.user = null;
                state.logged = false;
            }

        },
        setRole: (state, role) => {
            state.role = role;
        },
        setPhone: (state, phone) => {
            state.phone = phone
        },
        setName: (state, name) => {
            state.name = name;
        },
        setLastName: (state, lastName) => {
            state.lastName = lastName;
        },
        setImg: (state, imgUrl) => {
            state.imgUrl = imgUrl;
        }
    },
    getters: {
        logged: (state) => {
            return !!state.user;
        },
        role: (state) => {
            return state.role;
        },
        isCustomer: (state) => {
            return state.role === 'customer';
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/modules/auth.js